function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
import morphdom from 'morphdom';
import { verifyNotMutable, verifyNotPermanent } from './callbacks';
import { assignFocus, dispatch, xpathToElement, getClassNames, processElements } from './utils';
export var activeElement;
var shouldMorphCallbacks = [verifyNotMutable, verifyNotPermanent];
var didMorphCallbacks = [];

// Indicates whether or not we should morph an element via onBeforeElUpdated callback
// SEE: https://github.com/patrick-steele-idem/morphdom#morphdomfromnode-tonode-options--node
//
var shouldMorph = function shouldMorph(operation) {
  return function (fromEl, toEl) {
    return !shouldMorphCallbacks.map(function (callback) {
      return typeof callback === 'function' ? callback(operation, fromEl, toEl) : true;
    }).includes(false);
  };
};

// Execute any pluggable functions that modify elements after morphing via onElUpdated callback
//
var didMorph = function didMorph(operation) {
  return function (el) {
    didMorphCallbacks.forEach(function (callback) {
      if (typeof callback === 'function') callback(operation, el);
    });
  };
};
var DOMOperations = {
  // DOM Mutations

  append: function append(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-append', operation);
      var html = operation.html,
        focusSelector = operation.focusSelector;
      if (!operation.cancel) {
        element.insertAdjacentHTML('beforeend', html);
        assignFocus(focusSelector);
      }
      dispatch(element, 'cable-ready:after-append', operation);
    });
  },
  graft: function graft(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-graft', operation);
      var parent = operation.parent,
        focusSelector = operation.focusSelector;
      var parentElement = document.querySelector(parent);
      if (!operation.cancel && parentElement) {
        parentElement.appendChild(element);
        assignFocus(focusSelector);
      }
      dispatch(element, 'cable-ready:after-graft', operation);
    });
  },
  innerHtml: function innerHtml(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-inner-html', operation);
      var html = operation.html,
        focusSelector = operation.focusSelector;
      if (!operation.cancel) {
        element.innerHTML = html;
        assignFocus(focusSelector);
      }
      dispatch(element, 'cable-ready:after-inner-html', operation);
    });
  },
  insertAdjacentHtml: function insertAdjacentHtml(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-insert-adjacent-html', operation);
      var html = operation.html,
        position = operation.position,
        focusSelector = operation.focusSelector;
      if (!operation.cancel) {
        element.insertAdjacentHTML(position || 'beforeend', html);
        assignFocus(focusSelector);
      }
      dispatch(element, 'cable-ready:after-insert-adjacent-html', operation);
    });
  },
  insertAdjacentText: function insertAdjacentText(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-insert-adjacent-text', operation);
      var text = operation.text,
        position = operation.position,
        focusSelector = operation.focusSelector;
      if (!operation.cancel) {
        element.insertAdjacentText(position || 'beforeend', text);
        assignFocus(focusSelector);
      }
      dispatch(element, 'cable-ready:after-insert-adjacent-text', operation);
    });
  },
  morph: function morph(operation) {
    processElements(operation, function (element) {
      var html = operation.html;
      var template = document.createElement('template');
      template.innerHTML = String(html).trim();
      operation.content = template.content;
      dispatch(element, 'cable-ready:before-morph', operation);
      var childrenOnly = operation.childrenOnly,
        focusSelector = operation.focusSelector;
      var parent = element.parentElement;
      var ordinal = Array.from(parent.children).indexOf(element);
      if (!operation.cancel) {
        morphdom(element, childrenOnly ? template.content : template.innerHTML, {
          childrenOnly: !!childrenOnly,
          onBeforeElUpdated: shouldMorph(operation),
          onElUpdated: didMorph(operation)
        });
        assignFocus(focusSelector);
      }
      dispatch(parent.children[ordinal], 'cable-ready:after-morph', operation);
    });
  },
  outerHtml: function outerHtml(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-outer-html', operation);
      var html = operation.html,
        focusSelector = operation.focusSelector;
      var parent = element.parentElement;
      var ordinal = Array.from(parent.children).indexOf(element);
      if (!operation.cancel) {
        element.outerHTML = html;
        assignFocus(focusSelector);
      }
      dispatch(parent.children[ordinal], 'cable-ready:after-outer-html', operation);
    });
  },
  prepend: function prepend(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-prepend', operation);
      var html = operation.html,
        focusSelector = operation.focusSelector;
      if (!operation.cancel) {
        element.insertAdjacentHTML('afterbegin', html);
        assignFocus(focusSelector);
      }
      dispatch(element, 'cable-ready:after-prepend', operation);
    });
  },
  remove: function remove(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-remove', operation);
      var focusSelector = operation.focusSelector;
      if (!operation.cancel) {
        element.remove();
        assignFocus(focusSelector);
      }
      dispatch(document, 'cable-ready:after-remove', operation);
    });
  },
  replace: function replace(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-replace', operation);
      var html = operation.html,
        focusSelector = operation.focusSelector;
      var parent = element.parentElement;
      var ordinal = Array.from(parent.children).indexOf(element);
      if (!operation.cancel) {
        element.outerHTML = html;
        assignFocus(focusSelector);
      }
      dispatch(parent.children[ordinal], 'cable-ready:after-replace', operation);
    });
  },
  textContent: function textContent(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-text-content', operation);
      var text = operation.text,
        focusSelector = operation.focusSelector;
      if (!operation.cancel) {
        element.textContent = text;
        assignFocus(focusSelector);
      }
      dispatch(element, 'cable-ready:after-text-content', operation);
    });
  },
  // Element Property Mutations

  addCssClass: function addCssClass(operation) {
    processElements(operation, function (element) {
      var _element$classList;
      dispatch(element, 'cable-ready:before-add-css-class', operation);
      var name = operation.name;
      if (!operation.cancel) (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(getClassNames(name)));
      dispatch(element, 'cable-ready:after-add-css-class', operation);
    });
  },
  removeAttribute: function removeAttribute(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-remove-attribute', operation);
      var name = operation.name;
      if (!operation.cancel) element.removeAttribute(name);
      dispatch(element, 'cable-ready:after-remove-attribute', operation);
    });
  },
  removeCssClass: function removeCssClass(operation) {
    processElements(operation, function (element) {
      var _element$classList2;
      dispatch(element, 'cable-ready:before-remove-css-class', operation);
      var name = operation.name;
      if (!operation.cancel) (_element$classList2 = element.classList).remove.apply(_element$classList2, _toConsumableArray(getClassNames(name)));
      dispatch(element, 'cable-ready:after-remove-css-class', operation);
    });
  },
  setAttribute: function setAttribute(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-set-attribute', operation);
      var name = operation.name,
        value = operation.value;
      if (!operation.cancel) element.setAttribute(name, value);
      dispatch(element, 'cable-ready:after-set-attribute', operation);
    });
  },
  setDatasetProperty: function setDatasetProperty(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-set-dataset-property', operation);
      var name = operation.name,
        value = operation.value;
      if (!operation.cancel) element.dataset[name] = value;
      dispatch(element, 'cable-ready:after-set-dataset-property', operation);
    });
  },
  setProperty: function setProperty(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-set-property', operation);
      var name = operation.name,
        value = operation.value;
      if (!operation.cancel && name in element) element[name] = value;
      dispatch(element, 'cable-ready:after-set-property', operation);
    });
  },
  setStyle: function setStyle(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-set-style', operation);
      var name = operation.name,
        value = operation.value;
      if (!operation.cancel) element.style[name] = value;
      dispatch(element, 'cable-ready:after-set-style', operation);
    });
  },
  setStyles: function setStyles(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-set-styles', operation);
      var styles = operation.styles;
      for (var _i = 0, _Object$entries = Object.entries(styles); _i < _Object$entries.length; _i++) {
        var _ref3 = _Object$entries[_i];
        var _ref2 = _slicedToArray(_ref3, 2);
        var name = _ref2[0];
        var value = _ref2[1];
        if (!operation.cancel) element.style[name] = value;
      }
      dispatch(element, 'cable-ready:after-set-styles', operation);
    });
  },
  setValue: function setValue(operation) {
    processElements(operation, function (element) {
      dispatch(element, 'cable-ready:before-set-value', operation);
      var value = operation.value;
      if (!operation.cancel) element.value = value;
      dispatch(element, 'cable-ready:after-set-value', operation);
    });
  },
  // DOM Events

  dispatchEvent: function dispatchEvent(operation) {
    processElements(operation, function (element) {
      var name = operation.name,
        detail = operation.detail;
      dispatch(element, name, detail);
    });
  },
  // Browser Manipulations

  clearStorage: function clearStorage(operation) {
    dispatch(document, 'cable-ready:before-clear-storage', operation);
    var type = operation.type;
    var storage = type === 'session' ? sessionStorage : localStorage;
    if (!operation.cancel) storage.clear();
    dispatch(document, 'cable-ready:after-clear-storage', operation);
  },
  go: function go(operation) {
    dispatch(window, 'cable-ready:before-go', operation);
    var delta = operation.delta;
    if (!operation.cancel) history.go(delta);
    dispatch(window, 'cable-ready:after-go', operation);
  },
  pushState: function pushState(operation) {
    dispatch(window, 'cable-ready:before-push-state', operation);
    var state = operation.state,
      title = operation.title,
      url = operation.url;
    if (!operation.cancel) history.pushState(state || {}, title || '', url);
    dispatch(window, 'cable-ready:after-push-state', operation);
  },
  removeStorageItem: function removeStorageItem(operation) {
    dispatch(document, 'cable-ready:before-remove-storage-item', operation);
    var key = operation.key,
      type = operation.type;
    var storage = type === 'session' ? sessionStorage : localStorage;
    if (!operation.cancel) storage.removeItem(key);
    dispatch(document, 'cable-ready:after-remove-storage-item', operation);
  },
  replaceState: function replaceState(operation) {
    dispatch(window, 'cable-ready:before-replace-state', operation);
    var state = operation.state,
      title = operation.title,
      url = operation.url;
    if (!operation.cancel) history.replaceState(state || {}, title || '', url);
    dispatch(window, 'cable-ready:after-replace-state', operation);
  },
  scrollIntoView: function scrollIntoView(operation) {
    var element = operation.element;
    dispatch(element, 'cable-ready:before-scroll-into-view', operation);
    if (!operation.cancel) element.scrollIntoView(operation);
    dispatch(element, 'cable-ready:after-scroll-into-view', operation);
  },
  setCookie: function setCookie(operation) {
    dispatch(document, 'cable-ready:before-set-cookie', operation);
    var cookie = operation.cookie;
    if (!operation.cancel) document.cookie = cookie;
    dispatch(document, 'cable-ready:after-set-cookie', operation);
  },
  setFocus: function setFocus(operation) {
    var element = operation.element;
    dispatch(element, 'cable-ready:before-set-focus', operation);
    if (!operation.cancel) assignFocus(element);
    dispatch(element, 'cable-ready:after-set-focus', operation);
  },
  setStorageItem: function setStorageItem(operation) {
    dispatch(document, 'cable-ready:before-set-storage-item', operation);
    var key = operation.key,
      value = operation.value,
      type = operation.type;
    var storage = type === 'session' ? sessionStorage : localStorage;
    if (!operation.cancel) storage.setItem(key, value);
    dispatch(document, 'cable-ready:after-set-storage-item', operation);
  },
  // Notifications

  consoleLog: function consoleLog(operation) {
    var message = operation.message,
      level = operation.level;
    level && ['warn', 'info', 'error'].includes(level) ? console[level](message) : console.log(message);
  },
  notification: function notification(operation) {
    dispatch(document, 'cable-ready:before-notification', operation);
    var title = operation.title,
      options = operation.options;
    if (!operation.cancel) Notification.requestPermission().then(function (result) {
      operation.permission = result;
      if (result === 'granted') new Notification(title || '', options);
    });
    dispatch(document, 'cable-ready:after-notification', operation);
  },
  playSound: function playSound(operation) {
    dispatch(document, 'cable-ready:before-play-sound', operation);
    var src = operation.src;
    if (!operation.cancel) {
      var canplaythrough = function canplaythrough() {
        document.audio.removeEventListener('canplaythrough', canplaythrough);
        document.audio.play();
      };
      var ended = function ended() {
        document.audio.removeEventListener('ended', canplaythrough);
        dispatch(document, 'cable-ready:after-play-sound', operation);
      };
      document.audio.addEventListener('canplaythrough', canplaythrough);
      document.audio.addEventListener('ended', ended);
      document.audio.src = src;
      document.audio.play();
    } else dispatch(document, 'cable-ready:after-play-sound', operation);
  }
};
var perform = function perform(operations) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    emitMissingElementWarnings: true
  };
  for (var name in operations) {
    if (operations.hasOwnProperty(name)) {
      var entries = operations[name];
      for (var i = 0; i < entries.length; i++) {
        var operation = entries[i];
        try {
          if (operation.selector) {
            operation.element = operation.xpath ? xpathToElement(operation.selector) : document[operation.selectAll ? 'querySelectorAll' : 'querySelector'](operation.selector);
          } else {
            operation.element = document;
          }
          if (operation.element || options.emitMissingElementWarnings) {
            activeElement = document.activeElement;
            DOMOperations[name](operation);
          }
        } catch (e) {
          if (operation.element) {
            console.error("CableReady detected an error in ".concat(name, ": ").concat(e.message, ". If you need to support older browsers make sure you've included the corresponding polyfills. https://docs.stimulusreflex.com/setup#polyfills-for-ie11."));
            console.error(e);
          } else {
            console.log("CableReady ".concat(name, " failed due to missing DOM element for selector: '").concat(operation.selector, "'"));
          }
        }
      }
    }
  }
};
var performAsync = function performAsync(operations) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    emitMissingElementWarnings: true
  };
  return new Promise(function (resolve, reject) {
    try {
      resolve(perform(operations, options));
    } catch (err) {
      reject(err);
    }
  });
};
document.addEventListener('DOMContentLoaded', function () {
  if (!document.audio) {
    document.audio = new Audio('data:audio/mpeg;base64,//OExAAAAAAAAAAAAEluZm8AAAAHAAAABAAAASAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPz8/Pz8/Pz8/Pz8/Pz8/Pz8/Pz8/Pz8/P39/f39/f39/f39/f39/f39/f39/f39/f3+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/AAAAAAAAAAAAAAAAAAAAAAAAAAAAJAa/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//MUxAAAAANIAAAAAExBTUUzLjk2LjFV//MUxAsAAANIAAAAAFVVVVVVVVVVVVVV//MUxBYAAANIAAAAAFVVVVVVVVVVVVVV//MUxCEAAANIAAAAAFVVVVVVVVVVVVVV');
    var unlockAudio = function unlockAudio() {
      document.body.removeEventListener('click', unlockAudio);
      document.body.removeEventListener('touchstart', unlockAudio);
      document.audio.play().then(function () {}).catch(function () {});
    };
    document.body.addEventListener('click', unlockAudio);
    document.body.addEventListener('touchstart', unlockAudio);
  }
});
export default {
  perform: perform,
  performAsync: performAsync,
  DOMOperations: DOMOperations,
  shouldMorphCallbacks: shouldMorphCallbacks,
  didMorphCallbacks: didMorphCallbacks
};